<template>
  <div>
    <div class="row fixHeight p-0 m-0">
      <LiveLocatorMap :left-col-hidden="leftColHidden" :toggle-map="toggleMap" />
    </div>
    <BaseMapStylesDialog />
    <LiveLocatorDataCell :toggle-map="toggleMap" />
  </div>
</template>

<script lang="ts">

import { defineComponent } from 'vue';
import BaseMapStylesDialog from '.././base_map_dialog/BaseMapStylesDialog.vue';
import LiveLocatorDataCell from "./components/LiveLocatorDataCell.vue";
import LiveLocatorMap from "./components/LiveLocatorMap.vue";
import mapboxgl from "mapbox-gl";
import {GridRefUtils} from "../../utils/helpers/GridRefPreference";
import {RevenueCatWrapper} from "../../utils/RevenueCatWrapper";
import {HiikerMapStyle} from "../../utils/models/MapStyles";
import store from "./store/store";
import {LayerRegistry} from "../../utils/layer-registry";

export default defineComponent({
  components: { BaseMapStylesDialog, LiveLocatorMap, LiveLocatorDataCell },
  data() {
    return {
      leftColHidden: false,
    };
  },
  async beforeCreate() {
    this.$store.state.liveLocator.loading = true
    await this.$store.dispatch('mapStyles/initialiseStore');
  },
  async mounted() {
    await this.initialiseMap()
    this.$store.dispatch('liveLocator/getLiveLocatorData')
  },
  methods: {
    toggleMap() {
      this.$data.leftColHidden = !this.$data.leftColHidden;
      window.map.resize();
    },
    async initialiseMap() {
      mapboxgl.accessToken = "pk.eyJ1IjoiaGlpa2VyLW1hcHMiLCJhIjoiY2x0YThyZHppMWhmejJqbzExODBuY3dveiJ9.nBrtnXgbzxpAx_953HCB-w"
      const map = new mapboxgl.Map(this.$store.getters["liveLocator/mapOptions"]);
      const gridRef = GridRefUtils.preference();
      const isProOrProPlus = await RevenueCatWrapper.isProOrProPlus();
      map.setStyle(HiikerMapStyle.getCurrentStyle(isProOrProPlus).styleUrl)
      map.on('style.load', () => {
        console.log("Watching firebase")
        this.$store.dispatch('liveLocator/watchFirebase')
      });
      map.on('mousemove', (e) => {
        const coords = gridRef.convert(e.lngLat);
        store.commit('liveLocator/setMiniCoordsBar', coords.toString())
      });
      window.map = map;
      window.layerRegistry = new LayerRegistry(map);
    },
  },
});
</script>
